var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "nodeOptions"
  }, [_c('ul', _vm._l(_vm.optionList, function (_ref, idx) {
    var key = _ref.key,
        name = _ref.name,
        description = _ref.description,
        enable = _ref.enable;
    return _c('li', {
      attrs: {
        "disabled": !_vm.optionList[idx].enable
      },
      on: {
        "click": function ($event) {
          return _vm.setOption(key, enable);
        }
      }
    }, [_c('span', {
      style: {
        backgroundImage: _vm.getImageUrl(enable, name)
      }
    }), _c('button', [_vm._v(_vm._s(name))]), _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(description))])]);
  }), 0), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.treeMode == 'templeteEdit',
      expression: "treeMode=='templeteEdit'"
    }],
    on: {
      "click": _vm.saveTemplete
    }
  }, [_vm._v("템플릿 저장")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }